const Loading = (
  <div className="absolute w-full h-full bg-transparent flex justify-center items-center">
    <div className="bg-gray-300 rounded-md text-black w-32 h-32 flex justify-center items-center">
      Loading
    </div>
  </div>
);

export default Loading;
